module.exports = __webpack_public_path__ + "img/icon.e9a80b7b.svg";